import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/lib/react-query/queryKeys";
import {
  fetchInstitutionOptions,
  type InstitutionOption,
} from "../services/institutionOptionsService";

/** Institution dropdown options of the add-teacher form. */
export function useInstitutionOptions(options?: { enabled?: boolean }) {
  return useQuery<InstitutionOption[]>({
    queryKey: queryKeys.teachers.institutionOptions(),
    queryFn: fetchInstitutionOptions,
    staleTime: 60_000,
    refetchOnWindowFocus: false,
    enabled: options?.enabled ?? true,
  });
}
